import { ChakraProvider, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, useBoolean, useDisclosure } from "@chakra-ui/react";
import { useMemo, useState } from "react"
import { BiChevronDown, BiChevronLeft, BiChevronRight, BiFolder, BiFolderOpen } from "react-icons/bi";
import { BsCaretDown, BsFileEarmark, BsFolder, BsFolder2Open, BsPencilSquare, BsX } from "react-icons/bs";
import Loader from "../../components/loader/Loader";
import { lang } from "../../Utils";
import FavouriteModal from "./FavouriteModal";
import { deleteFavourite, getFavourites, saveFavourite } from "./Services";

const FavList = ({ attributes }) => {
  const { isOpen: isOpenDrawer, onOpen: onOpenDrawer, onClose: onCloseDrawer } = useDisclosure();
  const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();

  const [tree, setTree] = useState();
  const [loader, setLoader] = useBoolean();
  const [url, setUrl] = useState();
  const [search, setSearch] = useState();

  const loadData = () => {
    setLoader.on();
    getFavourites()
      .then(data => setTree(data))
      .finally(_ => setLoader.off());
  }

  const handleOpenDrawer = () => {
    onOpenDrawer();
    loadData();
  }

  const onSave = (data) => {
    setLoader.on();
    saveFavourite(data)
      .then(data => loadData())
      .finally(_ => setLoader.off());
  }

  const onDelete = (id) => {
    setLoader.on();
    deleteFavourite({ id: id })
      .then(data => {
        loadData();
        document.dispatchEvent(new Event('favourite-deleted'));
      })
      .finally(_ => setLoader.off());
  }

  const favouriteModal = useMemo(() => {
    if (isOpenModal) {
      return <FavouriteModal url={url} isOpen={isOpenModal} onClose={onCloseModal} onSave={onSave} onDelete={onDelete} />
    } else {
      return null
    }
  }, [isOpenModal]);

  const Folder = ({ value, children }) => {
    const [state, setState] = useState(false);
    return <ul className={`bf-favourite-folder ${(state) ? 'bf-open' : 'bf-close'}`} >
      <div className="bf-favourite-item-folder">
        <button type="button" onClick={() => { console.log('click'); setState(prevState => !prevState) }}>
          <span>{(!state) ? <BsFolder size={20} mr={1} /> : <BsFolder2Open size={20} mr={1} />}{value.name}</span>
        </button></div>
      {children}
    </ul>
  }

  const print = (values) => (!!values) ?
    values
      .filter(value => (!!value) ? new RegExp(search, 'gi').test(value.name) : true)
      .map((value, index) => <li className="bf-favourite-item">
        {(value.type === 'folder') ?
          <div><Folder value={value}>{print(value.items)}</Folder> </div> :
          <div className="bf-favourite-item-item">
            <a href={value.url}><BsFileEarmark size={20} />{value.name}</a>
            <BsPencilSquare onClick={() => { setUrl(value.url); onOpenModal() }} className="bf-favourite-editable" />
          </div>
        }
      </li >) : null;

  return (<ChakraProvider>
    <button type="button" className="bf-favourite-list-button" onClick={handleOpenDrawer}>{lang(attributes.label)}</button>
    <Drawer
      isOpen={isOpenDrawer}
      placement='right'
      onClose={onCloseDrawer}
      size="sm">
      <DrawerOverlay />
      <DrawerContent className="bf-sidepanel-detail">
        <DrawerCloseButton />
        <DrawerHeader>{lang('Favourites')}</DrawerHeader>
        <DrawerBody h={'100%'} className="bf-favourite-sidepanel-body">
          {(loader) ? <Loader /> :
            <>
              <div className="bf-search-clear">
                <input placeholder={lang('type here')} onChange={(event) => setSearch(event.target.value)} value={search} />
                <button type="button" onClick={() => setSearch('')}><BsX /></button>
              </div>
              <ul className="bf-favourite-list">{print(tree)}</ul>
            </>}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
    {favouriteModal}
  </ChakraProvider >)
}
export { FavList };